import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import { SxProps } from "@mui/material";
import * as React from "react";

import { FilterDropdown, type FilterOption } from "./FilterDropdown";
import {
  type UserFacingStatus,
  USER_FACING_STATUSES,
} from "./invocationStatusUtils";

interface InvocationStatusFilterProps {
  selectedStatuses: UserFacingStatus[];
  onStatusChange: (statuses: UserFacingStatus[]) => void;
  sx?: SxProps;
}

const STATUS_OPTIONS: FilterOption[] = USER_FACING_STATUSES.map((status) => ({
  label: status,
  value: status,
}));

export default function InvocationStatusFilter({
  selectedStatuses,
  onStatusChange,
  sx,
}: InvocationStatusFilterProps) {
  const handleStatusChange = React.useCallback(
    (values: string[]) => {
      onStatusChange(values as UserFacingStatus[]);
    },
    [onStatusChange],
  );

  return (
    <FilterDropdown
      options={STATUS_OPTIONS}
      selectedValues={selectedStatuses}
      onChange={handleStatusChange}
      buttonTitle="Status"
      title="Filter by Status"
      buttonIcon={<PlaylistAddCheckIcon />}
      sx={sx}
      testId="status-filter"
    />
  );
}
